import http from '@/util/http'
// 成交供应商/潜在供应商/黑名单
export function queryAllSupplierBase (suState, page, size, data) {
  return http({
    url: `/api/supplierBase/queryByOwnIdSupplierBase/${suState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
//  团队供应商
export function querySupplierBaseAll (suState, page, size, data) {
  return http({
    url: `/api/supplierBase/querySupplierBaseAll/${suState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 分配负责人
export function updatePrincipal (data) {
  return http({
    url: '/api/supplierBase/updatePrincipal',
    method: 'post',
    data: data
  })
}

// 采购合同转移负责人
export function purchaseContract (suId, ownId, oldOwnId, data) {
  return http({
    url: `/api/supplierBase/updateByOwnIdPurchaseContract/${suId}/${ownId}/${oldOwnId}`,
    method: 'post',
    data: data
  })
}
// 供应商上传-文件
export function supplierBaseAdd (data) {
  return http({
    url: '/api/supplierBase/add',
    method: 'post',
    data: data
  })
}

// 添加供应商-添加代理品牌
export function queryByGuidsAttachment (data) {
  return http({
    url: '/api/supplierManageinfo/queryByGuidsAttachment',
    method: 'post',
    data: data
  })
}
// 获取供应商编码
export function querySupplierBySuCode (data) {
  return http({
    url: '/api/supplierBase/queryBySuCode',
    method: 'get'
  })
}
// 供应商验证名称是否重复
export function supplierBaseQueryByCusName (suName) {
  return http({
    url: `/api/supplierBase/queryByCusName/${suName}`,
    method: 'get'
  })
}
// 根据供应商id查看详情
export function queryAllSupplierBaseById (id) {
  return http({
    url: `/api/supplierBase/queryAllSupplierBase/${id}`,
    method: 'get'
  })
}
// 报价管理列表
export function queryBySupplierOfferSummary (page, size, data) {
  return http({
    url: `/api/supplierOfferSummary/queryBySupplierOfferSummary/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 活动管理列表
export function supplierActivityList (page, size, data) {
  return http({
    url: `/api/supplierActivity/queryPageAll/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 根据供应商id修改供应商
export function supplierBaseUpdateById (data) {
  return http({
    url: '/api/supplierBase/update',
    method: 'post',
    data: data
  })
}
// 供应商卡看板-搜索
export function querySupplierMoney (suId, data) {
  return http({
    url: `/api/supplierBase/querySupplierMoney/${suId}`,
    method: 'post',
    data: data
  })
}
// 根据联系人id和供应商id(suId)修改供应商联系人
export function supplierConnectUpdateById (data) {
  return http({
    url: '/api/supplierConnect/update',
    method: 'post',
    data: data
  })
}
// 根据联系人id删除供应商联系人
export function supplierConnectDelete (id) {
  return http({
    url: `/api/supplierConnect/delete/${id}`,
    method: 'get'
  })
}
// 根据id删除收货信息
export function supplierRecgoodsDelete (id) {
  return http({
    url: `/api/supplierRecevieGoods/delete/${id}`,
    method: 'post'
  })
}
// 删除交易账户
export function supplierBankDelete (id) {
  return http({
    url: `/api/supplierBank/delete/${id}`,
    method: 'post'
  })
}
// 设为主联系人
export function supplierConnectUpdateByIsDefault (id, suId) {
  return http({
    url: `/api/supplierConnect/updateByIsDefault/${id}/${suId}`,
    method: 'post'
  })
}
// 设为主收货人
export function supplierRecevieGoodsByIsDefault (id, suId) {
  return http({
    url: `/api/supplierRecevieGoods/updateByIsDefault/${id}/${suId}`,
    method: 'post'
  })
}
// 设为主账号
export function supplierBankUpdateByIsDefault (id, suId) {
  return http({
    url: `/api/supplierBank/updateByIsDefault/${id}/${suId}`,
    method: 'post'
  })
}
// 根据供应商id(suId)和开票id修改供应商开票信息
export function supplierInvoiceUpdateById (data) {
  return http({
    url: '/api/supplierInvoice/update',
    method: 'post',
    data: data
  })
}
// 根据供应商id和交易账户id修改交易账户信息
export function supplierBankUpdateById (suId, data) {
  return http({
    url: `/api/supplierBank/update/${suId}`,
    method: 'post',
    data: data
  })
}
// 根据供应商id(suId)和收货id修改收货信息
export function supplierRecgoodsUpdateById (suId, data) {
  return http({
    url: `/api/supplierRecevieGoods/updateRecevie/${suId}`,
    method: 'post',
    data: data
  })
}
// 根据供应商id(suMiid)添加代理品牌/系列
export function supplierManageinfoAdd (data) {
  return http({
    url: '/api/supplierManageinfo/add',
    method: 'post',
    data: data
  })
}
// 根据id和供应商id(suId)删除代理品牌/系列
export function supplierManageinfoDelete (id, suId) {
  return http({
    url: `/api/supplierManageinfo/delete/${id}/${suId}`,
    method: 'post'
  })
}
// 根据供应商id加入/移出黑名单
export function supplierBaseUpdateByShift (id, state) {
  return http({
    url: `/api/supplierBase/updateByShift/${id}/${state}`,
    method: 'post'
  })
}
// 根据供应商id查看报价明细列表
export function queryBySupplierOfferQuoteCollect (suId, page, size, data) {
  return http({
    url: `/api/supplierOffer/queryBySupplierOffer/${suId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 获取报价单表头和供应商报价表头所有关联
export function supplierHeaderTemplateQueryAll (data) {
  return http({
    url: '/api/supplierHeaderTemplate/queryAll',
    method: 'post',
    data: data
  })
}
// 报价单表头关联供应商报价表头
export function supplierHeaderTemplateAdd (data) {
  return http({
    url: '/api/supplierHeaderTemplate/add',
    method: 'post',
    data
  })
}
// 分配负责人
export function updateByStaffUsename (id, suId) {
  return http({
    url: `/api/supplierOfferSummary/updateByStaffUsename/${id}/${suId}`,
    method: 'post'
  })
}
// 获取报价中所有负责人
export function queryAllByChargeStaffId () {
  return http({
    url: '/api/supplierOfferSummary/queryAllByChargeStaffId',
    method: 'post'
  })
}
// 报价导入数据
export function supplierOfferAdd (suId, expire, data) {
  return http({
    url: `/api/supplierOffer/add/${suId}/${expire}`,
    method: 'post',
    data: data
  })
}
// 导入报价单时数据预览
export function supplierOfferQueryByExcel () {
  return http({
    url: '/api/supplierOffer/queryByExcel',
    method: 'post'
  })
}

// 清空报价
export function deleteSupplierOffer (suId, state, data) {
  return http({
    url: `/api/supplierOfferSummary/deleteSupplierOffer/${suId}/${state}`,
    method: 'post',
    data: data
  })
}
// 根据供应商id查看日志
export function pageQueryBySuidOperationLog (page, size, suId) {
  return http({
    url: `/api/supplierOfferSummaryList/pageQueryBySuid/${page}/${size}/${suId}`,
    method: 'post'
  })
}
// 获取所有添加人信息
export function queryAllCreateUser (suId) {
  return http({
    url: `/api/supplierOffer/queryAllCreateUser/${suId}`,
    method: 'post'
  })
}
// 删除活动
export function supplierActivityDelete (id) {
  return http({
    url: `/api/supplierActivity/delete/${id}`,
    method: 'post'
  })
}
// 获取所有供应商
export function queryAllSupplier (suName, data) {
  return http({
    url: '/api/supplierBase/queryAllSupplier',
    method: 'post',
    params: {
      suName: suName
    }

  })
}
// 结束活动
export function supplierActivityUpdateByState (data) {
  return http({
    url: '/api/supplierActivity/updateByState',
    method: 'post',
    data: data
  })
}
// 添加活动
export function supplierActivityAdd (data) {
  return http({
    url: '/api/supplierActivity/add',
    method: 'post',
    data: data
  })
}
// 根据活动id查看活动内容
export function supplierActivityQueryById (id) {
  return http({
    url: `/api/supplierActivity/queryById/${id}`,
    method: 'get'
  })
}
// 修改活动
export function supplierActivityUpdate (data) {
  return http({
    url: '/api/supplierActivity/update',
    method: 'post',
    data: data
  })
}
// 根据供应商id查看供应商账户
export function seeSupplierBank (suId) {
  return http({
    url: `/api/supplierBank/queryBySuId/${suId}`,
    method: 'get'
  })
}

// 添加银行账号
export function addBank (data) {
  return http({
    url: '/api/supplierBank/add',
    method: 'post',
    data: data
  })
}
// 发起充值
export function add (data) {
  return http({
    url: '/api/supplierRechargeApproval/add',
    method: 'post',
    data: data
  })
}

// 根据供应商Id查询充值记录
export function seeRechargeApproval (subId, page, size) {
  return http({
    url: `/api/supplierRechargeApproval/queryBySuId/${subId}/${page}/${size}`,
    method: 'get'
  })
}
// 采购管理-根据id查询充值详情
export function queryRechargeDetailById (id) {
  return http({
    url: `/api/supplierRechargeApproval/queryRechargeDetailById/${id}`,
    method: 'get'
  })
}
// 采购管理-根据id查询充值详情
export function restartSupplierRecharge (id) {
  return http({
    url: `/api/supplierRechargeApproval/restartSupplierRecharge/${id}`,
    method: 'get'
  })
}

// 供应商余额统计//
export function querySupplierAccountList (page, size, data) {
  return http({
    url: `/api/supplierAcountBase/querySupplierAccountList/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 供应商余额统计-列表导出
export function exportSupplierAccountList (data) {
  return http({
    url: '/api/supplierAcountBase/exportSupplierAccountList',
    method: 'get',
    responseType: 'blob',
    data: data
  })
}

// 报价查询
export function queryProductByName (page, size, name) {
  return http({
    url: `/api/productBase/queryProductByName/${page}/${size}/${name}`,
    method: 'post'
  })
}

export function querySupplierByPro (page, size, proId) {
  return http({
    url: `/api/supplierOffer/querySupplierByPro/${page}/${size}/${proId}`,
    method: 'post'
  })
}
